import { Box } from "@mui/material";
import { StatefulPopover } from "baseui/popover";
import { PLACEMENT } from "baseui/tooltip";
import { useEffect, useState } from "react";
import BriaButton from "../../../../../../../components/common/BriaButton/BriaButton";
import BriaTooltip from "../../../../../../../components/common/BriaTooltip/BriaTooltip";
import { useAppStore } from "../../../../../../../hooks/useStores";
import useDesignEditorUtils, { FeatureType } from "../../../../../../CustomUtils/UseDesignEditor";
import TextAlignCenter from "../../../../../../components/Icons/TextAlignCenter";
import TextAlignJustify from "../../../../../../components/Icons/TextAlignJustify";
import TextAlignLeft from "../../../../../../components/Icons/TextAlignLeft";
import TextAlignRight from "../../../../../../components/Icons/TextAlignRight";
import { useActiveObject } from "../../../../../../hooks/useActiveObject";
import { useEditor } from "../../../../../../hooks/useEditor";
import { IStaticText, LayerType } from "../../../../../../types";
import styles from "./TextAlign.module.scss";

const TextAlign = () => {
	const TEXT_ALIGNS = ["left", "center", "right", "justify"];

	const editor = useEditor();
	const activeObject = useActiveObject() as Required<IStaticText>;
	const [state, setState] = useState<{ align: string }>({ align: "left" });
	const { EditAllAds } = useDesignEditorUtils();
	const { campaignStore } = useAppStore();

	useEffect(() => {
		if (activeObject) {
			// @ts-ignore
			setState({ align: activeObject.textAlign });
		}
	}, [activeObject]);

	const reAssignTheFixedWidthAndHeightToTheActiveObject = () => {
		const active = editor?.canvas?.canvas.getActiveObject();

		if (active) {
			const activeObj: fabric.Object = active;
			if (
				activeObj &&
				activeObj?.type === LayerType.STATIC_TEXT &&
				activeObj.fixedSize &&
				activeObj.fixedWidthValue &&
				activeObj.fixedHeightValue &&
				activeObj.width &&
				activeObj.height &&
				activeObj.fontSize
			) {
				if (activeObj.width > activeObj.fixedWidthValue) {
					activeObj.set("width", activeObj.fixedWidthValue);
				}
				if (activeObj.height > activeObj.fixedHeightValue) {
					activeObj.set("height", activeObj.fixedHeightValue);
				}
				activeObj.set("width", activeObj.fixedWidthValue);
				activeObj.set("height", activeObj.fixedHeightValue);
			}
		}
	};
	return (
		<StatefulPopover
			showArrow={true}
			placement={PLACEMENT.bottom}
			overrides={{
				Body: {
					style: {
						zIndex: "1600",
					},
				},
			}}
			content={() => (
				<Box className={styles.alignContainer}>
					<BriaButton
						disableRipple
						className={`${state.align === TEXT_ALIGNS[0] ? styles.selectedButton : ""} ${
							styles.alignButton
						}`}
						onClick={() => {
							editor?.objects.update(
								{ textAlign: TEXT_ALIGNS[0] },
								undefined,
								!campaignStore.isEditingAllAds,
							);
							reAssignTheFixedWidthAndHeightToTheActiveObject();
							setState({ align: TEXT_ALIGNS[0] });
							EditAllAds(
								LayerType.STATIC_TEXT,
								activeObject.textType,
								FeatureType.TEXT_ALIGN,
								TEXT_ALIGNS[0],
							);
						}}
					>
						<TextAlignLeft size={20} />
					</BriaButton>
					<BriaButton
						disableRipple
						className={`${state.align === TEXT_ALIGNS[1] ? styles.selectedButton : ""} ${
							styles.alignButton
						}`}
						onClick={(e) => {
							e.stopPropagation();
							editor?.objects.update(
								{ textAlign: TEXT_ALIGNS[1] },
								undefined,
								!campaignStore.isEditingAllAds,
							);
							reAssignTheFixedWidthAndHeightToTheActiveObject();
							setState({ align: TEXT_ALIGNS[1] });
							EditAllAds(
								LayerType.STATIC_TEXT,
								activeObject.textType,
								FeatureType.TEXT_ALIGN,
								TEXT_ALIGNS[1],
							);
						}}
					>
						<TextAlignCenter size={20} />
					</BriaButton>
					<BriaButton
						disableRipple
						className={`${state.align === TEXT_ALIGNS[2] ? styles.selectedButton : ""} ${
							styles.alignButton
						}`}
						onClick={() => {
							editor?.objects.update(
								{ textAlign: TEXT_ALIGNS[2] },
								undefined,
								!campaignStore.isEditingAllAds,
							);
							setState({ align: TEXT_ALIGNS[2] });
							reAssignTheFixedWidthAndHeightToTheActiveObject();
							EditAllAds(
								LayerType.STATIC_TEXT,
								activeObject.textType,
								FeatureType.TEXT_ALIGN,
								TEXT_ALIGNS[2],
							);
						}}
					>
						<TextAlignRight size={20} />
					</BriaButton>
					<BriaButton
						disableRipple
						className={`${state.align === TEXT_ALIGNS[3] ? styles.selectedButton : ""} ${
							styles.alignButton
						}`}
						onClick={() => {
							editor?.objects.update(
								{ textAlign: TEXT_ALIGNS[3] },
								undefined,
								!campaignStore.isEditingAllAds,
							);
							reAssignTheFixedWidthAndHeightToTheActiveObject();
							setState({ align: TEXT_ALIGNS[3] });
							EditAllAds(
								LayerType.STATIC_TEXT,
								activeObject.textType,
								FeatureType.TEXT_ALIGN,
								TEXT_ALIGNS[3],
							);
						}}
					>
						<TextAlignJustify size={20} />
					</BriaButton>
				</Box>
			)}
			returnFocus
			autoFocus
		>
			<Box>
				<BriaTooltip title={"Align"} placement="bottom">
					<BriaButton className={styles.align}>
						{state.align === TEXT_ALIGNS[0] ? (
							<TextAlignLeft size={20} />
						) : state.align === TEXT_ALIGNS[1] ? (
							<TextAlignCenter size={20} />
						) : state.align === TEXT_ALIGNS[2] ? (
							<TextAlignRight size={20} />
						) : (
							<TextAlignJustify size={20} />
						)}
					</BriaButton>
				</BriaTooltip>
			</Box>
		</StatefulPopover>
	);
};

export default TextAlign;
